import type { PendingLegalDocument } from "src/types/federation-communication";

type PendingLegalDocumentsResponse = { items: PendingLegalDocument[] };

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

// FS-2026-030/036: an invalid response must never mean "nothing to accept".
export function isPendingLegalDocumentsResponse(
  value: unknown,
): value is PendingLegalDocumentsResponse {
  return (
    isRecord(value) &&
    Array.isArray(value.items) &&
    value.items.every(
      (item) =>
        isRecord(item) &&
        ["id", "document_id", "provider_id", "version", "revision"].every(
          (key) => Number.isSafeInteger(item[key]) && Number(item[key]) > 0,
        ) &&
        (item.kind === "terms" || item.kind === "privacy") &&
        ["title", "body", "notice", "locale", "provider_name"].every(
          (key) => typeof item[key] === "string",
        ) &&
        typeof item.checksum === "string" &&
        /^[a-f0-9]{64}$/i.test(item.checksum) &&
        typeof item.selected === "boolean" &&
        typeof item.guardian_required === "boolean" &&
        (item.published_at === null || typeof item.published_at === "string"),
    )
  );
}
